<template>
    <MainPage pageTitle="สิทธิพิเศษ" bgClass="bg-white" :menuBar="false">
        <div>
            <div class="grid justify-items-center mt-4">
                <div>
                    <img
                        class="object-cover max-w-72 max-h-72"
                        src="@/assets/NotRegister/Illustration_NotRegister@3x.png"
                        alt=""
                    />
                </div>
                <div class="m-auto mx-4 text-center ">
                    <div class="text-22 mb-8 text-a-gray-afafaf leading-9 font-medium">
                        คุณยังไม่ได้ลงทะเบียน
                        <br />
                        ใช้งานไลน์ ธนชาตประกันภัย
                    </div>
                    <div class="text-12 text-a-gray-afafaf leading-5">
                        หากพบปัญหาการใช้งาน
                        <br />
                        ติดต่อศูนย์บริการลูกค้า ธนชาตประกันภัย
                        <br />
                        <div
                            class="text-12 text-a-orange-fe5000 underline underline-offset-2"
                            @click="callPhone()"
                        >
                            โทร. 02-308-9222
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="bottom-nav">
                <MainButton size="lg" @click="clickLink()">
                    ลงทะเบียนทันที
                </MainButton>
            </div>
        </div>
    </MainPage>
</template>
<script>
import MainPage from "@/components/Layout/Page/MainPage.vue";
import MainButton from '@/components/Button/MainButton.vue';

export default {
    name: "NotRegister",
    components: {
        MainPage,
        MainButton
    },
    methods: {
        clickLink: function() {
            window.location.replace('/registerstandard/consent')
        },
        callPhone: function() {
            window.open("tel:023089222");
        }
    }
};
</script>
<style lang="scss" scoped>
.bottom-nav {
    @apply fixed left-0 right-0 bottom-0 w-full max-w-lg mx-auto flex flex-col items-center justify-center p-6;
}
</style>
